import { Box, Modal } from "@mui/material";
import "./chooseAccountType.scss";
import { BrandButton, BrandButtonWhite } from "./form/buttons";

interface Props {
  open: boolean;
  setAccountType: (type: number) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}

const ChooseAccountType = ({ open, setAccountType }: Props) => {
  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="chooseAccountType">
        <div className="boxHolder">
          <div className="cta">
            <div className="col1">
              <h4>TWO WAYS TO PAY:</h4>
              <div className="calloutHolder">
                <div className="item">
                  <div className="numberHolder">1</div>
                  <div className="calloutText">
                    <h5>ONE-TIME PAYMENT</h5>
                    <p>
                      Lorem ipsum dolor sit amet,consectetur adipiscing elit.
                    </p>
                    <BrandButtonWhite onClick={() => setAccountType(0)}>
                      START NOW &gt;
                    </BrandButtonWhite>
                  </div>
                </div>
                <div className="item">
                  <div className="numberHolder alt">2</div>
                  <div className="calloutText">
                    <h5>PAY AS YOU GO</h5>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </p>
                    <BrandButton onClick={() => setAccountType(1)}>
                      START NOW &gt;
                    </BrandButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};
export default ChooseAccountType;
